import { DatePipe } from "@angular/common"
import { Pipe, PipeTransform } from "@angular/core"
import { firestore } from "firebase/app"
import * as moment from "moment"
@Pipe({
  name: "trDate",
})
export class TrDatePipe implements PipeTransform {
  public static toDate(date: any): Date {
    if (!date) {
      return null
    }

    // Firebase Date
    const newDate = date
    try {
      if (newDate.seconds) {
        return new firestore.Timestamp(newDate.seconds, newDate.nanoseconds || 0).toDate()
      }

      if (newDate._seconds) {
        return new firestore.Timestamp(newDate._seconds, newDate._nanoseconds || 0).toDate()
      }

      if (newDate.toDate) {
        return date.toDate()
      }
    } catch (err) {
      // Ignore thrown error
    }

    // Any other date
    const momentDate = moment(newDate)
    if (!momentDate.isValid()) {
      return null
    }

    return momentDate.toDate()
  }

  public transform(date: any, format: string = "short"): string {
    const newDate = TrDatePipe.toDate(date)
    if (!newDate) {
      return ""
    }

    return new DatePipe("en-US").transform(newDate, format)
  }

  public static getDay(date: any): number {
    return +moment(date).format("D")
  }

  public static getMonth(date: any): number {
    return +moment(date).format("M")
  }

  public static getYear(date: any): number {
    return +moment(date).format("YYYY")
  }
}
